import React from 'react';
import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import moment from 'moment';
import irelandApi from '../irelandApi';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';

const toDateString = value => (value ? moment.parseZone(value).format('YYYY-MM-DD') : value);

const compactFilters = filters => Object.entries(filters)
  .reduce((acc, [key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});

export const getQrCodeCampaigns = (filters = {}) => (dispatch) => {
  dispatch({ type: 'GET_QR_CODE_CAMPAIGNS_PENDING' });
  return irelandApi.get('/api/admin/qr_code_campaigns', { params: compactFilters(filters) })
    .then((response) => {
      dispatch({ type: 'GET_QR_CODE_CAMPAIGNS_FULFILLED', payLoad: response.data });
    })
    .catch((error) => {
      const data = (error.response && error.response.data) || error;
      dispatch({ type: 'GET_QR_CODE_CAMPAIGNS_REJECTED', payLoad: data });
    });
};

export const getQrCodeCampaignMeta = () => (dispatch) => {
  dispatch({ type: 'GET_QR_CODE_CAMPAIGN_META_PENDING' });
  return irelandApi.get('/api/admin/qr_code_campaigns/new')
    .then((response) => {
      dispatch({ type: 'GET_QR_CODE_CAMPAIGN_META_FULFILLED', payLoad: response.data });
    })
    .catch((error) => {
      const data = (error.response && error.response.data) || error;
      dispatch({ type: 'GET_QR_CODE_CAMPAIGN_META_REJECTED', payLoad: data });
    });
};

export const getQrCodeCampaign = id => (dispatch) => {
  dispatch({ type: 'GET_QR_CODE_CAMPAIGN_PENDING' });
  return irelandApi.get(`/api/admin/qr_code_campaigns/${id}`)
    .then((response) => {
      dispatch({ type: 'GET_QR_CODE_CAMPAIGN_FULFILLED', payLoad: response.data });
      return response.data;
    })
    .catch((error) => {
      const data = (error.response && error.response.data) || error;
      dispatch({ type: 'GET_QR_CODE_CAMPAIGN_REJECTED', payLoad: data });
    });
};

const preparePayload = (payLoad) => {
  const { abm_codes: abmCodes, ...rest } = payLoad;
  const groupIds = (payLoad.group_ids || []).map(group => group.value);
  const abmsAttributes = (abmCodes || []).map(abmCode => ({ abm_code: abmCode.value }));

  return {
    ...rest,
    start_date: toDateString(payLoad.start_date),
    end_date: toDateString(payLoad.end_date),
    group_ids: groupIds,
    qr_code_campaigns_abms_attributes: abmsAttributes
  };
};

const onSaveSuccess = () => {
  toast.success(<ToastMessage
    iconStyle="success"
    message="QR code campaign has been saved successfully"
  />);
  history.push('/admin/qr_code_campaigns');
};

const onSaveError = (error) => {
  toast.error(<ToastMessage
    iconStyle="error"
    message="An error occurred while saving the QR code campaign"
  />);
  store.dispatch(actions.resetValidity('deep.admin_qr_code_campaign'));
  const errors = error && error.response && error.response.data && error.response.data.errors;
  const data = errors ? { ...errors } : {};
  return Promise.reject(data);
};

export const saveQrCodeCampaign = payLoad =>
  irelandApi.post('/api/admin/qr_code_campaigns', { qr_code_campaign: preparePayload(payLoad) })
    .then(onSaveSuccess)
    .catch(onSaveError);

export const updateQrCodeCampaign = (id, payLoad) =>
  irelandApi.patch(`/api/admin/qr_code_campaigns/${id}`, { qr_code_campaign: preparePayload(payLoad) })
    .then(onSaveSuccess)
    .catch(onSaveError);
